import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { InventoryService } from "../services/InventoryService";

const styles: string = css`
    :host {
        font-family: "Onesize";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.6); /* Semi-transparent background */
        z-index: 1000;
    }

    .inventory-container {
        background: #2c2c2c;
        color: #fff;
        padding: 20px;
        border-radius: 12px;
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.8);
        max-width: 400px;
        width: 90%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
    }

    .inventory-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #444;
        padding-bottom: 10px;
        margin-bottom: 15px;
    }

    .inventory-header h2 {
        margin: 0;
        font-size: 1.5rem;
        flex-grow: 1;
        text-align: center;
    }

    .close-btn {
        background: none;
        border: none;
        color: #fff;
        font-size: 1.2rem;
        cursor: pointer;
        transition: color 0.3s;
    }

    .close-btn:hover {
        color: #ff5555;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        width: 100%;
    }

    li {
        padding: 12px;
        background: #444;
        margin: 5px 0;
        border-radius: 6px;
        cursor: pointer;
        transition: background 0.3s, transform 0.2s;
    }

    li:hover {
        background: #555;
        transform: scale(1.05);
    }

    .empty-message {
        color: #bbb;
        font-style: italic;
        margin: 10px 0;
        padding: 12px;
        background: #383838;
        border-radius: 6px;
    }
`;

export class InventoryComponent extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();

    private _inventoryService: InventoryService = new InventoryService();
    private _currentInventory: string[] = [];

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        void this.refreshInventory();
    }

    private async refreshInventory(): Promise<void> {
        const inventory: string[] = await this._inventoryService.getInventory();
        this.updateGameState(inventory);
    }

    private updateGameState(inventory: string[]): void {
        this._currentInventory = inventory;

        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        const element: HTMLElement = this.renderInventory();

        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.appendChild(element);
    }

    private renderInventory(): HTMLElement {
        const element: HTMLElement = html`
            <div>
                <style>
                    ${styles}
                </style>
                <div class="inventory-container">
                    <div class="inventory-header">
                        <h2>Inventory</h2>
                        <button class="close-btn" id="close-inventory">✖</button>
                    </div>
                    <ul>
                        ${this._currentInventory.length > 0
                            ? this._currentInventory.map(item => html`<li>${item}</li>`)
                            : html`<li class="empty-message">No items in inventory</li>`}
                    </ul>
                </div>
            </div>  
        `;

        requestAnimationFrame(() => {
            const closeButton: Element | null = element.querySelector("#close-inventory");
            if (closeButton) {
                closeButton.addEventListener("click", () => {
                    this._gameEventService.switchPage(Page.Canvas);
                });
            }
        });

        return element;
    }
}
